var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPosNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335.302 335.302",
    style: {
      enableBackground: "new 0 0 335.302 335.302"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.555 0h-42.422c-12.278 0-23.913 8.69-27.063 20.558L233.956 81H14.814c-4.089 0-7.811 1.67-10.479 4.614C1.667 88.558.419 92.445.82 96.515l11.405 115.809C13.011 220.298 20.17 227 28.182 227h183.423c7.753 0 15.413-6.066 17.438-13.551l21.406-79.26c.593-1.066 1.068-2.061 1.395-3.295L278.672 30h40.884c8.284 0 15-6.716 15-15S327.84 0 319.555 0zM221.17 257h-202c-8.284 0-15 6.716-15 15s6.716 15 15 15h8.781a33.51 33.51 0 0 0-3.321 14.585c0 18.591 15.125 33.717 33.718 33.717 18.591 0 33.717-15.125 33.717-33.717A33.51 33.51 0 0 0 88.744 287h66.737a33.51 33.51 0 0 0-3.321 14.585c0 18.591 15.125 33.717 33.717 33.717s33.718-15.125 33.718-33.717A33.51 33.51 0 0 0 216.274 287h4.898c8.284 0 15-6.716 15-15s-6.718-15-15.002-15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPosNavigation);
export default __webpack_public_path__ + "static/media/icon_pos_navigation.7c79b78ad2df60ef1b6a99ff3aa24e50.svg";
export { ForwardRef as ReactComponent };